import React, { useState, useEffect, useMemo, useCallback } from 'react';
import {
   Modal,
   ModalOverlay,
   ModalContent,
   useColorModeValue,
   ModalHeader,
   ModalCloseButton,
   ModalBody,
   Grid,
   GridItem,
   Button,
   Checkbox,
   RadioGroup,
   Stack,
   Radio,
   ModalFooter,
   useToast,
} from '@chakra-ui/react';
import { useForm, Controller } from 'react-hook-form';
import { InputBox } from 'components/inputBox/InputBox';
import { useDispatch, useSelector } from 'react-redux';
import { addVendor, updateVendor, getVendors } from '../../../../../redux/actions/vendor';
// import { getCountries } from '../../../../../redux/actions/country';
// import { getCities } from '../../../../../redux/actions/city';
// import { getStates } from '../../../../../redux/actions/state';
import { renderDynamicDropdown as renderDynamicUiDropdown } from 'components/ui/DynamicDropdown';
import { renderFormControl, renderSelectFormControl } from 'utils/DynamicFormData';
import * as Yup from 'yup';
import { GL_GROUP_TYPE } from '../../../../../constants/index';
import { getShareCompanyOptions } from '../../../../../utils/util';
import { useGlobal } from '../../../../../contexts/GlobalContext';
import { useUser } from 'contexts';

const validationSchema = Yup.object().shape({
   name: Yup.string().required('Name is required').min(3, 'Name must be at least 3 characters long'),
   // pincode: Yup.number()
   //   .min(6, 'Pincode must be at least 6 characters long')
   //   .max(6, 'Pincode must be at least 6 characters long'),
   // phone: Yup.number()
   //   .min(10, 'Phone must be at least 10 characters long')
   //   .max(10, 'Phone must be at least 10 characters long'),
});

const VendorMasterForm = ({ isOpen, onClose, isEditMode = false, initialData = null, isAbs = false }) => {
   const { cityList, stateList, countryList, companyList, userGlobalSettingsData } = useGlobal();
   // const countryList = useSelector((state) => state.country.list);
   // const stateList = useSelector((state) => state.state.list);
   // const cityList = useSelector((state) => state.city.list);
   // const account = useSelector((state) => state.account.single);

   // const [city, setCity] = useState([...cityList]);
   // const [state, setState] = useState([...stateList]);
   // const [country, setCountry] = useState([...countryList]);

   const [isSameAddress, setIsSameAddress] = useState(true);
   const toast = useToast();
   const dispatch = useDispatch();
   const { control } = useForm();
   const { user } = useUser();
   // const watchedFields = watch();

   const textColor = useColorModeValue('gray.800', 'white');
   const dbName = localStorage.getItem('dbName');
   const [errors, setErrors] = useState({});

   const [row, setRow] = useState({
      compIds: [],
      name: '',
      mobile: null,
      panNo: '',
      gst: '',
      address: '',
      pincode: null,
      balance: '',
      balanceType: '',
      stateId: null,
      coId: null,
      cityId: null,
      areaId: null,
      glGroupId: GL_GROUP_TYPE.VENDOR,
      addressJson: [],
      shippingAddress: '',
      shippingCityId: '',
      shippingStateId: '',
      shippingCoId: '',
      shippingPincode: '',
   });

   const globalSetting = userGlobalSettingsData?.[0]?.askCompany?.account;
   const shouldShowCompanyDropdown = globalSetting || false;
   // Memoized values
   const companyOptions = useMemo(() => {
      return getShareCompanyOptions({ dbName, company: companyList });
   }, [companyList, dbName]);

   const handleCompanyChange = useCallback((selectedOptions) => {
      setRow((prev) => ({
         ...prev,
         compIds: selectedOptions ?? [],
      }));
   }, []);

   const lastcompanyOptions = useMemo(
      () =>
         companyOptions.map((company) => ({
            value: company.value,
            label: company.label,
            id: company.value,
            name: company.label,
         })),
      [companyOptions],
   );

   const clearFormData = () => {
      setRow({
         name: '',
         mobile: '',
         panNo: '',
         gst: '',
         address: '',
         pincode: '',
         balance: '',
         balanceType: '',
         stateId: '',
         coId: '',
         areaId: '',
         glGroupId: '',
         addressJson: [],
         shippingAddress: '',
         shippingCityId: '',
         shippingStateId: '',
         shippingCoId: '',
         shippingPincode: '',
      });
      setErrors({});
   };

   useEffect(() => {
      if (user?.loginhistory?.companyId && !isEditMode) {
         // Only set if not in edit mode and compIds is empty or doesn't include the user's company
         setRow((prev) => {
            if (prev.compIds.length === 0 || !prev.compIds.includes(user.loginhistory.companyId)) {
               return {
                  ...prev,
                  compIds: [user.loginhistory.companyId],
               };
            }
            return prev;
         });
      }
   }, [user?.loginhistory?.companyId, isEditMode]);

   useEffect(() => {
      if (!isEditMode) {
         clearFormData(); // Clear data when adding a new item
         setRow((prev) => ({
            ...prev,
            status: true, // Set status to 1 when adding a new customer
            compIds: user?.loginhistory?.companyId ? [user.loginhistory.companyId] : [],
         }));
      } else if (isEditMode && initialData) {
         const billingAddress = initialData?.accountaddress?.find((addr) => addr.name === 'billing') || {};
         const shippingAddress = initialData?.accountaddress?.find((addr) => addr.name === 'shipping') || {};
         // const selectedCity = cityList.find((city) => city.id === initialData?.accountaddress?.cityId);
         // const stateId = selectedCity?.stId || initialData?.accountaddress?.stateId;
         // const selectedState = stateList.find((state) => state.id === stateId);
         // const coId = selectedState?.coId || initialData?.accountaddress?.coId;
         setRow({
            name: initialData?.name || '',
            mobile: initialData?.mobile || '',
            panNo: initialData?.panNo || '',
            gst: initialData?.gst || '',
            balance: initialData?.balance || '',
            balanceType: initialData?.balanceType || '',
            status: initialData?.status || false,
            compIds: initialData?.companyIds || [],
            // stateId: stateId || '',
            // coId: coId || '',
            city: billingAddress?.city || '',
            address: billingAddress?.address || '',
            pincode: billingAddress?.pincode || '',
            stateId: billingAddress?.stateId || null,
            coId: billingAddress?.coId || null,
            areaId: billingAddress?.areaId || null,
            cityId: billingAddress?.cityId || null,
            shippingAddress: shippingAddress?.address || '',
            shippingCityId: shippingAddress?.cityId || '',
            shippingStateId: shippingAddress?.stateId || '',
            shippingCoId: shippingAddress?.coId || '',
            shippingPincode: shippingAddress?.pincode || '',
            // city: initialData?.addressJson[0]?.city || '',
         });
         setIsSameAddress(!shippingAddress.address);
      }
   }, [isEditMode, initialData, cityList, stateList]);

   const validateStep = async () => {
      try {
         // Validate the whole row object instead of individual fields
         await validationSchema.validate(row, { abortEarly: false });

         setErrors({}); // Clear previous errors
         return true;
      } catch (err) {
         if (err instanceof Yup.ValidationError) {
            const errorObj = {};
            err.inner.forEach((error) => {
               errorObj[error.path] = error.message;
            });
            setErrors(errorObj);
            return false;
         }
         return false;
      }
   };

   const handleInputChange = (field, value) => {
      // setRow((prev) => ({
      //   ...prev,
      //   [field]: value,
      // }));
      setRow((prev) => {
         const updatedRow = { ...prev, [field]: value };

         // Autofill state and country when cityId is selected
         if (field === 'cityId') {
            const selectedCity = cityList.find((city) => city.id === Number(value));

            if (selectedCity) {
               updatedRow.stateId = selectedCity.stId; // Auto-fill state
               const selectedState = stateList.find((state) => state.id === selectedCity.stId);
               if (selectedState) {
                  updatedRow.coId = selectedState.coId; // Auto-fill country
               }
            }
         }

         if (field === 'stateId') {
            const selectedState = stateList.find((state) => state.id === Number(value));
            if (selectedState) {
               updatedRow.coId = selectedState.coId; // Auto-fill country based on state
            }
         }

         if (field === 'shippingCityId') {
            const selectedCity = cityList.find((city) => city.id === Number(value));
            if (selectedCity) {
               updatedRow.shippingStateId = selectedCity.stId; // Auto-fill shipping state
               const selectedState = stateList.find((state) => state.id === selectedCity.stId);
               if (selectedState) {
                  updatedRow.shippingCoId = selectedState.coId; // Auto-fill shipping country
               }
            }
         }

         if (field === 'shippingStateId') {
            const selectedState = stateList.find((state) => state.id === Number(value));
            if (selectedState) {
               updatedRow.shippingCoId = selectedState.coId; // Auto-fill shipping country based on state
            }
         }

         return updatedRow;
      });

      // setTimeout(() => {
      //   setRow((prev) => ({ ...prev }));
      // }, 0);

      // Clear the specific field error when user starts typing
      setErrors((prevErrors) => {
         const newErrors = { ...prevErrors };
         if (newErrors[field]) {
            delete newErrors[field];
         }
         return newErrors;
      });
   };

   // const handleSameAddressChange = (e) => {
   //   const isChecked = e.target.checked;
   //   setIsSameAddress(isChecked);

   //   // If checked, copy the billing address to the shipping address in addressJson
   //   if (isChecked) {
   //     // const billingAddress = watchedFields.address || '';
   //     setRow({ shippingAddress: row.address });
   //   } else {
   //     setRow({ shippingAddress: '' });
   //     // Optionally, you can clear the shipping address if the checkbox is unchecked.
   //     // setValue('addressJson.0.address', '');
   //   }
   // };

   const handleSameAddressChange = (e) => {
      const isChecked = e.target.checked;
      setIsSameAddress(isChecked);

      if (isChecked) {
         // When checkbox is checked, copy main address to shipping address
         setRow((prev) => ({
            ...prev,
            shippingAddress: prev.address,
            shippingCityId: prev.cityId,
            shippingStateId: prev.stateId,
            shippingCoId: prev.coId,
            shippingPincode: prev.pincode,
         }));
      } else {
         // When checkbox is unchecked, clear the shipping address fields for editing
         setRow((prev) => ({
            ...prev,
            shippingAddress: '',
            shippingCityId: '',
            shippingStateId: '',
            shippingCoId: '',
            shippingPincode: '',
         }));
      }
   };
   const onFormSubmit = async () => {
      const billingAddress = initialData?.accountaddress?.find((addr) => addr.name === 'billing') || {};
      const shippingAddress = initialData?.accountaddress?.find((addr) => addr.name === 'shipping') || {};
      let addressJson = {
         ...(isEditMode && initialData ? { id: billingAddress.id } : {}),
         name: 'billing',
         address: row.address,
         gst: row.gst,
         mobile: row.mobile,
         email: row?.email || '',
         pincode: row.pincode,
         areaId: row.areaId || null,
         coId: row.coId,
         stateId: row.stateId,
         cityId: row.cityId,
      };
      let shippingAddressJson = {
         ...(isEditMode && initialData ? { id: shippingAddress.id } : {}),
         name: 'shipping',
         address: row.shippingAddress || row.address, // Use shippingAddress if provided
         pincode: row.shippingPincode || '', // Use shippingPincode for the shipping address
         areaId: row.areaId || null,
         coId: row.shippingCoId || row.coId, // Use shippingCoId if available
         stateId: row.shippingStateId || row.stateId, // Use shippingStateId if available
         cityId: row.shippingCityId || row.cityId, // Use shippingCityId if available
      };
      const processedData = {
         glGroupId: GL_GROUP_TYPE.VENDOR,
         name: row.name,
         gst: row.gst,
         mobile: row.mobile,
         email: row.email,
         panNo: row.panNo,
         pincode: row.pincode,
         areaId: row.areaId || null,
         addressJson: [addressJson],
         status: row.status,
      };

      if (!isSameAddress) {
         processedData.addressJson.push(shippingAddressJson);
      }

      try {
         if (isEditMode && initialData && initialData.id) {
            // Update existing item
            processedData.id = initialData.id;
            // processedData.
            await dispatch(updateVendor(processedData));
         } else {
            // Add new item
            await dispatch(addVendor(processedData));
         }

         // Close the modal
         await dispatch(getVendors());
         onClose();
      } catch (error) {
         toast({
            title: 'Error',
            description: error.message || 'An error occurred while saving the category.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      }
   };

   const handleSubmit = async () => {
      const isValid = await validateStep();
      if (isValid) {
         onFormSubmit(); // Call the form submit logic if validation is successful
      } else {
         toast({
            title: 'Validation Error',
            description: 'Please correct the errors before saving 44.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      }
   };

   // useEffect(() => {
   //   if(isOpen){
   //     dispatch(getCountries());
   //     dispatch(getStates());
   //     dispatch(getCities());
   //   }
   // }, [dispatch , isOpen]);

   return (
      <>
         <Modal isOpen={isOpen} onClose={onClose} size="3xl" scrollBehavior="inside" overflowY="scroll">
            <ModalOverlay />
            <ModalContent
               bg={useColorModeValue('white', '#2d3748')}
               color={useColorModeValue('gray.800', 'white')}
               borderRadius="20px"
               p={5}
               boxShadow="lg"
               maxHeight="90vh"
               overflow="auto">
               <ModalHeader fontSize="36px" fontWeight="600" mb={4}>
                  {isEditMode ? 'Edit Vendor' : 'Add New Vendor'}
               </ModalHeader>
               <ModalCloseButton />
               <ModalBody>
                  <form>
                     <Grid templateColumns="repeat(2, 1fr)" gap={6}>
                        <GridItem>
                           {renderFormControl(
                              'name',
                              'Name',
                              {
                                 value: row.name,
                                 onChange: (e) => handleInputChange('name', e.target.value),
                                 disabled: isEditMode && isAbs,
                              },
                              errors,
                              textColor,
                              'text',
                              true, // optional: mark as required
                           )}
                        </GridItem>
                        <GridItem>
                           {renderFormControl(
                              'mobile',
                              'Mobile',
                              {
                                 value: row.mobile,
                                 onChange: (e) => handleInputChange('mobile', e.target.value),
                              },
                              errors,
                              textColor,
                              'number',
                              false, // optional: mark as required
                           )}
                        </GridItem>
                        <GridItem>
                           {renderFormControl(
                              'gst',
                              'GST',
                              {
                                 value: row.gst,
                                 onChange: (e) => handleInputChange('gst', e.target.value),
                              },
                              errors,
                              textColor,
                              'text',
                              false, // optional: mark as required
                           )}
                        </GridItem>
                        <GridItem>
                           {renderFormControl(
                              'panNo',
                              'Pan No',
                              {
                                 value: row.panNo,
                                 onChange: (e) => handleInputChange('panNo', e.target.value),
                              },
                              errors,
                              textColor,
                              'text',
                              false, // optional: mark as required
                           )}
                        </GridItem>
                        <GridItem colSpan={2}>
                           {renderFormControl(
                              'address',
                              'Address',
                              {
                                 value: row.address,
                                 onChange: (e) => handleInputChange('address', e.target.value),
                              },
                              errors,
                              textColor,
                              'text',
                              false, // optional: mark as required
                           )}
                        </GridItem>

                        <GridItem colSpan={2}>
                           <Grid templateColumns="repeat(3, 1fr)" gap={6}>
                              <GridItem w="100%">
                                 {renderSelectFormControl(
                                    'cityId',
                                    'City',
                                    cityList,
                                    {
                                       value: row.cityId,
                                       onChange: (value) => handleInputChange('cityId', value),
                                    },
                                    errors,
                                    textColor,
                                    false, // isRequired
                                    'Select City', // placeholder
                                 )}
                              </GridItem>
                              <GridItem w="100%">
                                 {renderSelectFormControl(
                                    'stateId',
                                    'State',
                                    stateList,
                                    {
                                       value: row.stateId,
                                       onChange: (value) => handleInputChange('stateId', value),
                                       isDisabled: Boolean(row.stateId && row.cityId), // Disable when auto-filled
                                    },
                                    errors,
                                    textColor,
                                    false, // isRequired
                                    'Select State', // placeholder
                                 )}
                              </GridItem>
                              <GridItem w="100%">
                                 {renderSelectFormControl(
                                    'coId',
                                    'Country',
                                    countryList,
                                    {
                                       value: row.coId,
                                       onChange: (value) => handleInputChange('coId', value),
                                       isDisabled: !!row.stateId, // Disable when a state is selected
                                    },
                                    errors,
                                    textColor,
                                    false, // isRequired
                                    'Select Country', // placeholder
                                 )}
                              </GridItem>
                           </Grid>
                        </GridItem>
                        <GridItem>
                           {renderFormControl(
                              'pincode',
                              'Pincode',
                              {
                                 value: row.pincode,
                                 onChange: (e) => handleInputChange('pincode', e.target.value),
                              },
                              errors,
                              textColor,
                              'number',
                              false, // optional: mark as required
                           )}
                        </GridItem>
                        <GridItem colSpan={2}>
                           <Checkbox isChecked={isSameAddress} onChange={handleSameAddressChange}>
                              Shipping Address Same as above
                           </Checkbox>
                        </GridItem>

                        {/* Only render the following fields if the "Shipping Address Same as above" is unchecked */}
                        {!isSameAddress && (
                           <>
                              <GridItem colSpan={2}>
                                 {renderFormControl(
                                    'shippingAddress',
                                    'Shipping Address',
                                    {
                                       value: row.shippingAddress,
                                       onChange: (e) => handleInputChange('shippingAddress', e.target.value),
                                    },
                                    errors,
                                    textColor,
                                    'text',
                                    false,
                                 )}
                              </GridItem>

                              <GridItem colSpan={2}>
                                 <Grid templateColumns="repeat(3, 1fr)" gap={6}>
                                    <GridItem>
                                       {renderSelectFormControl(
                                          'shippingCityId',
                                          'Shipping City',
                                          cityList,
                                          {
                                             value: row.shippingCityId,
                                             onChange: (value) => handleInputChange('shippingCityId', value),
                                             disabled: isSameAddress, // Disable if the checkbox is checked
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select City',
                                       )}
                                    </GridItem>

                                    <GridItem>
                                       {renderSelectFormControl(
                                          'shippingStateId',
                                          'Shipping State',
                                          stateList,
                                          {
                                             value: row.shippingStateId,
                                             onChange: (value) => handleInputChange('shippingStateId', value),
                                             isDisabled: Boolean(row.shippingStateId && row.shippingCityId), // Disable if the checkbox is checked
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select State',
                                       )}
                                    </GridItem>

                                    <GridItem>
                                       {renderSelectFormControl(
                                          'shippingCoId',
                                          'Shipping Country',
                                          countryList,
                                          {
                                             value: row.shippingCoId,
                                             onChange: (value) => handleInputChange('shippingCoId', value),
                                             isDisabled: !!row.shippingStateId, // Disable if the checkbox is checked
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Country',
                                       )}
                                    </GridItem>
                                 </Grid>
                              </GridItem>

                              <GridItem colSpan={2}>
                                 {renderFormControl(
                                    'shippingPincode',
                                    'Shipping Pincode',
                                    {
                                       value: row.shippingPincode,
                                       onChange: (e) => handleInputChange('shippingPincode', e.target.value),
                                    },
                                    errors,
                                    textColor,
                                    'number',
                                    false,
                                 )}
                              </GridItem>
                           </>
                        )}

                        {/* <GridItem colSpan={2}>
                  <Grid templateColumns="repeat(3, 1fr)" gap={6}>
                    <GridItem w="100%">
                      {renderSelectFormControl(
                        'cityId',
                        'City',
                        cityList,
                        {
                          value: row.cityId,
                          onChange: (e) =>
                            handleInputChange('cityId', e.target.value),
                        },
                        errors,
                        textColor,
                        false, // isRequired
                        'Select City', // placeholder
                      )}
                    </GridItem>
                    <GridItem w="100%">
                      {renderSelectFormControl(
                        'stateId',
                        'State',
                        stateList,
                        {
                          value: row.stateId,
                          onChange: (e) =>
                            handleInputChange('stateId', e.target.value),
                          isDisabled: Boolean(row.stateId && row.cityId), // Disable when auto-filled
                        },
                        errors,
                        textColor,
                        false, // isRequired
                        'Select State', // placeholder
                      )}
                    </GridItem>
                    <GridItem w="100%">
                      {renderSelectFormControl(
                        'coId',
                        'Country',
                        countryList,
                        {
                          value: row.coId,
                          onChange: (e) =>
                            handleInputChange('coId', e.target.value),
                          isDisabled: !!row.stateId,
                        },
                        errors,
                        textColor,
                        false, // isRequired
                        'Select Country', // placeholder
                      )}
                    </GridItem>
                  </Grid>
                </GridItem> */}

                        <GridItem>
                           <div>Opening Balance :</div>

                           <Controller
                              name="balanceType"
                              control={control}
                              defaultValue="payable"
                              onChange={(e) => handleInputChange('balanceType', e.target.value)}
                              render={({ field }) => (
                                 <RadioGroup {...field}>
                                    <Stack spacing={5} direction="row">
                                       <Radio colorScheme="red" value="amount">
                                          Amount
                                       </Radio>
                                       <Radio colorScheme="orange" value="payable">
                                          Payable
                                       </Radio>
                                       <Radio colorScheme="green" value="receivable">
                                          Receivable
                                       </Radio>
                                    </Stack>
                                 </RadioGroup>
                              )}
                           />
                        </GridItem>
                        {shouldShowCompanyDropdown && (
                           <GridItem className="seperator-width">
                              {renderDynamicUiDropdown(
                                 'company',
                                 'Company',
                                 lastcompanyOptions,
                                 {
                                    value: row.compIds,
                                    onChange: handleCompanyChange,
                                 },
                                 {},
                                 textColor,
                                 false,
                                 'Select company',
                                 true,
                                 undefined,
                                 true,
                              )}
                           </GridItem>
                        )}

                        <GridItem>
                           {renderFormControl(
                              'balance',
                              'Balance',
                              {
                                 value: row.balance,
                                 onChange: (e) => handleInputChange('balance', e.target.value),
                              },
                              errors,
                              textColor,
                              'number',
                              false, // optional: mark as required
                           )}
                        </GridItem>
                     </Grid>
                  </form>
               </ModalBody>
               <ModalFooter>
                  <Button
                     type="submit"
                     onClick={handleSubmit}
                     variant="darkBrand"
                     color="white"
                     fontSize="sm"
                     fontWeight="500"
                     borderRadius="full"
                     px="24px"
                     py="5px"
                     _active={{ bg: '#06b' }}
                     mr={5}>
                     {isEditMode ? 'Update' : 'Save'}
                  </Button>
                  <Button variant="ghost" onClick={onClose}>
                     Cancel
                  </Button>
               </ModalFooter>
            </ModalContent>
         </Modal>
      </>
   );
};

export default VendorMasterForm;
